var render = function render(){var _vm=this,_c=_vm._self._c;return _c('grid',{attrs:{"items":_vm.agents,"mode":"agent","cols":3,"perPage":-1}})
}
var staticRenderFns = []

export { render, staticRenderFns }